<template>
  <div class="space-y-4">
    <div class="flex items-center">
      <div class="flex-1">
        <p>{{ t('child-select.child-age-info.provide-age') }}</p>
        <p class="text-xs text-gray-500">
          {{ t('child-select.child-age-info.at-departure-time') }}
        </p>
      </div>
      <UiCloseButton @click="$emit('onHideGrid')" />
    </div>
    <div class="age-grid grid">
      <UiCheckboxButton
        v-for="age in ages"
        :key="age"
        :is-selected="age === selectedAge"
        class="age-button text-sm font-semibold text-black"
        :class="{
          'col-span-2': age === 0,
          'aspect-square min-h-11 min-w-11': age > 0,
        }"
        @click="selectAge(age)"
      >
        {{ getAgeButtonText(age) }}
      </UiCheckboxButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';

  import { UiCloseButton, UiCheckboxButton } from '@shared/ui';
  import { MAX_CHILD_AGE } from '@entities/passengers-state';
  import { useChildSelectLocales } from '../locales';

  defineProps<{ selectedAge?: number }>();

  const emit = defineEmits<{
    onAgeSelect: [age: number];
    onHideGrid: [];
  }>();

  const { t } = useChildSelectLocales();

  /**
   * @description We convert the value to an array, that starts
   * from 0 and goes to `MAX_CHILD_AGE`
   *
   * Since it basically creates an array of indexes from 0 to `MAX_CHILD_AGE`,
   * it will stop at 1 number below `MAX_CHILD_AGE`, so , we need to add `+1`
   * to ensure that the last age is actually equal to `MAX_CHILD_AGE`
   */
  const ages = computed(() => Array.from(Array(MAX_CHILD_AGE + 1).keys()));

  const getAgeButtonText = (age: number) => {
    if (age === 0) {
      return t('child-select.under-one-year');
    }

    return age;
  };

  const selectAge = (age: number) => {
    emit('onAgeSelect', age);
  };
</script>

<style scoped>
  .age-grid {
    grid-template-columns: repeat(auto-fill, minmax(44px, 1fr));
    gap: var(--age-grid-gap, 1rem);
  }

  .age-button {
    --checkbox-btn-default-bg: theme('colors.gray.150');
  }
</style>
